import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/orders',
  title: 'Pedidos',
  endpoint: '/app/expedition/order',
  breadcrumbs: [],
}
